import React, { useState, useEffect,useReducer, Fragment } from "react";
import {
  Grid,
  Paper,
  TextField,
  Button,
  InputAdornment,
  Typography,
  Snackbar,
  CircularProgress,
} from "@material-ui/core";
import { generate } from "shortid";
import { produce } from "immer";
import MSelect from "../components/Select/Select";
import uuid from "uuid/v4";
import Select from "react-select";
import CarrierOption from "../components/CarrierOption/CarrierOption";
import useStyles from "./styles/stylesCotizacion";
import SnackbarWrapper from "../components/SnackbarContentWrapper/SnackbarContentWrapper";
// import drEnvioLogo from '../logos/drEnvioLogo.jpeg'

import { estados,estadosUS, services, paises } from "../constants/constants";
import useCotizacionAPI from "../hooks/useCotizacionAPI";
import useSaldosAPI from "../hooks/useSaldosAPI";
import useGuiasAPI from "../hooks/useGuiasAPI";
import useGetDirecciones from "../hooks/direcciones/useGetDirecciones";
import useGetPaquetes from "../hooks/paquetes/useGetPaquetes";
import useGetDestinatarios from "../hooks/destinatarios/useGetDestinatarios";

import { useAuth0 } from "../hooks/react-auth0-spa";
import Modal from "../components/Modal/Modal";

import "./styles/style.css";
// import { useForm, Controller } from "react-hook-form";

const findDestinatario = (_id = "", destinatarios = []) => {
  const r = destinatarios.find((el) => el._id === _id);
  return r ? r.nombre : "";
};

const Cotizacion = () => {
  /** Si ya se hizo la cotizacion */
  const [showCotizacion, setShowCotizacion] = useState(false);
  /**Estados */
  const [estadoRemitente, setEstadoRemitente] = useState(null);
  const [estadoDestinatario, setEstadoDestinatario] = useState(null);
  const [paisDestinatario, setPaisDestinatario] = useState({label:'México', value:'MX'});
  /**Calles */
  const [calleRemitente, setCalleRemitente] = useState("");
  const [calleDestinatario, setCalleDestinatario] = useState("");
  /**Contenido */
  const [contenido, setContenido] = useState("");
  /**Numero */
  const [numeroRemitente, setNumeroRemitente] = useState("");
  const [numeroDestinatario, setNumeroDestinatario] = useState("");
  /**Colonias */
  const [coloniaRemitente, setColoniaRemitente] = useState("");
  const [coloniaDestinatario, setColoniaDestinatario] = useState("");
  /**Delegaciones */
  const [delegacionRemitente, setDelegacionRemitente] = useState("");
  const [delegacionDestinatario, setDelegacionDestinatario] = useState("");
  /**Destinatario */
  const [referenciaDestinatario, setReferenciaDestinatario] = useState("");
  const [referenciaRemitente, setReferenciaRemitente] = useState("");
  /**States del destinatario */
  const [nombreDestinatario, setNombreDestinatario] = useState("");
  const [telefonoDestinatario, setTelefonoDestinatario] = useState("");
  const [emailDestinatario, setEmailDestinatario] = useState("");
  const [empresaDestinatario, setEmpresaDestinatario] = useState("");
  /**Codigo postal */
  const [cpRemitente, setCPRemitente] = useState("");
  const [cpDestinatario, setCPDestinatario] = useState("");
  /**Dimensiones */
  const [largo, setLargo] = useState("");
  const [alto, setAlto] = useState("");
  const [ancho, setAncho] = useState("");
  const [peso, setPeso] = useState("");
  const [asegurar, setAsegurar] = useState(0);
  const [valorEnvio, setValorEnvio] = useState(0);
  /**Listado Cotizaciones */
  const [listadoCarriers, setListadoCarriers] = useState([]);
  const [option, setOption] = useState({});
  const [paquete, setPaquete] = useState("");
  

  
  const [commodities, setCommoditie] = useState([
      {description:'',quantity:'',price:''}
  ]);

  const [direccionRemitente, setDireccionRemitente] = useState("");
  const [direccionDestinatario, setDireccionDestinatario] = useState("");

  const [{ data, isLoading }, doCotizacion] = useCotizacionAPI({});
  const [
    { data: dataGuia, isLoading: isLoadingGuia, isError: errorGuia },
    doGenerar,
  ] = useGuiasAPI({});
  const [
    { data: direcciones, isLoading: isLoadingDir },
    getDirecciones,
  ] = useGetDirecciones();
  const [
    { data: paquetes, isLoading: isLoadingPaquetes },
    getPaquetes,
  ] = useGetPaquetes();
  const [{ data: destinatarios }] = useGetDestinatarios();

  const [, fetchSaldo] = useSaldosAPI();
  const { loading } = useAuth0();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorSaldo, setErrorSaldo] = useState(false);
  useEffect(() => {
    setErrorSaldo(errorGuia);
  }, [errorGuia]);

  const classes = useStyles();

  useEffect(() => {
    getDirecciones("yes");
    getPaquetes("yes");
  }, [direcciones, getDirecciones, getPaquetes]);

  useEffect(() => {
    resetGenerar();
    // eslint-disable-next-line
  }, [
    estadoRemitente,
    estadoDestinatario,
    cpRemitente,
    cpDestinatario,
    alto,
    ancho,
    peso,
  ]);

  useEffect(() => {
    if (!direccionRemitente) return;
    resetGenerar();
    setShowCotizacion(false);
    const dir = direcciones.find((el) => direccionRemitente === el._id);
    setEstadoRemitente(estados.find((el) => el.value === dir.estado));
    setCPRemitente(dir.cp);
    setCalleRemitente(dir.calle);
    setNumeroRemitente(dir.numero);
    setColoniaRemitente(dir.colonia);
    setDelegacionRemitente(dir.delegacion);
    setReferenciaRemitente(dir.referencia);
    // eslint-disable-next-line
  }, [direccionRemitente, direcciones]);

  useEffect(() => {
    if (!direccionDestinatario) return;
    resetGenerar();
    setShowCotizacion(false);
    const dir = direcciones.find((el) => direccionDestinatario === el._id);
    setEstadoDestinatario(estados.find((el) => el.value === dir.estado));
    setCPDestinatario(dir.cp);
    setCalleDestinatario(dir.calle);
    setNumeroDestinatario(dir.numero);
    setColoniaDestinatario(dir.colonia);
    setDelegacionDestinatario(dir.delegacion);
    setReferenciaDestinatario(dir.referencia);
    const destinatario = destinatarios.find(
      (el) => dir.destinatario === el._id
    );
    if (!destinatario) return;
    // console.log(destinatario);
    setNombreDestinatario(destinatario.nombre);
    setEmailDestinatario(destinatario.correo);
    setTelefonoDestinatario(destinatario.telefono);
    setEmpresaDestinatario(destinatario.empresa);
    // eslint-disable-next-line
  }, [direccionDestinatario]);
  const resetGenerar = () => {
    if (direccionDestinatario || direccionRemitente || paquete) return;
    setOption({});
    setCalleRemitente("");
    setCalleDestinatario("");
    setNumeroRemitente("");
    setNumeroDestinatario("");
    setColoniaRemitente("");
    setColoniaDestinatario("");
    setDelegacionRemitente("");
    setDelegacionDestinatario("");
    setNombreDestinatario("");
    setEmailDestinatario("");
    setTelefonoDestinatario("");
    setEmpresaDestinatario("");
    setShowCotizacion(false);
  };

  useEffect(() => {
    if (!paquete) return;
    resetGenerar();
    setShowCotizacion(false);
    const pack = paquetes.find((el) => paquete === el._id);
    setAlto(pack.alto);
    setAncho(pack.ancho);
    setLargo(pack.largo);
    setContenido(pack.contenido);
    setPeso(pack.peso);
    // eslint-disable-next-line
  }, [paquete]);


  const handleSelectDirRemitente = (id = "") => {
    setDireccionRemitente(id);
  };
  const handleSelectDirDestinatario = (id = "") => {
    setDireccionDestinatario(id);
  };

  const handleSelectPaquete = (id = "") => {
    setPaquete(id);
  };

  const handleModalClose = () => {
    fetchSaldo(Math.random());
    setShowModal(false);
  };


  const validateDatos = () => {
    const errores = [];
    if (!calleDestinatario) errores.push("calle del destinatario");
    if (!calleRemitente) errores.push("calle del remitente");
    if (!numeroRemitente) errores.push("numero del remitente");
    if (!numeroDestinatario) errores.push("numero del destinatario");
    if (!coloniaRemitente) errores.push("colonia del remitente");
    if (!coloniaDestinatario) errores.push("colonia del destinatario");
    if (!delegacionDestinatario) errores.push("delegación del destinatario");
    if (!delegacionRemitente) errores.push("delegación del remitente");
    if (!nombreDestinatario) errores.push("nombre del destinatario");
    if (!emailDestinatario) errores.push("email del destinatario");
    if (!telefonoDestinatario) errores.push("telefono del destinattario");
    if (!contenido) errores.push("contenido del paquete");
    if (Object.keys(option).length === 0) errores.push("opción de paquetería");
    if (calleRemitente.length < 10 || calleDestinatario.length < 10)
      errores.push("las calles deben tener al menos 10 caracteres");

    if (errores.length > 0) {
      setErrorMessage(
        "Falta por rellenar / corregir los siguientes campos: " +
          errores.join(", ")
      );
      setShowError(true);
      return false;
    }
    return true;
  };
  const validateDatosInternacional = () => {
    const errores = [];
    if (!calleDestinatario) errores.push("calle del destinatario");
    if (!calleRemitente) errores.push("calle del remitente");
    if (!numeroRemitente) errores.push("numero del remitente");
    if (!numeroDestinatario) errores.push("numero del destinatario");
    if (!coloniaRemitente) errores.push("colonia del remitente");
    if (!delegacionDestinatario) errores.push("delegación del destinatario");
    if (!delegacionRemitente) errores.push("delegación del remitente");
    if (!nombreDestinatario) errores.push("nombre del destinatario");
    if (!emailDestinatario) errores.push("email del destinatario");
    if (!telefonoDestinatario) errores.push("telefono del destinattario");
    if (!contenido) errores.push("contenido del paquete");
    if(commodities[0].description.length===0||commodities[0].quantity.length===0||commodities[0].price.length===0) errores.push("Debe agregar minimo 1 articulo en la descripción");
    if (Object.keys(option).length === 0) errores.push("opción de paquetería");
    if (calleRemitente.length < 10 || calleDestinatario.length < 10)
      errores.push("las calles deben tener al menos 10 caracteres");

    if (errores.length > 0) {
      setErrorMessage(
        "Falta por rellenar / corregir los siguientes campos: " +
          errores.join(", ")
      );
      setShowError(true);
      return false;
    }
    return true;
  };

  const validateCotizacion = () => {
    // console.log("khe");
    const errores = [];
    if (!estadoRemitente) errores.push("estado del remitente");
    if (!estadoDestinatario) errores.push("estado del destinatario");
    if (!paisDestinatario) errores.push("país del destinatario");
    if (!cpRemitente) errores.push("código postal del remitente");
    if (!cpDestinatario) errores.push("código postal del destinatario");
    if (!largo || largo === 0) errores.push("largo del paquete");
    if (!alto || alto === 0) errores.push("alto del paquete");
    if (!peso || peso === 0) errores.push("peso del paquete");
    if (!ancho || ancho === 0) errores.push("ancho del paquete");

    if (errores.length > 0) {
      setErrorMessage(
        "Falta por rellenar / corregir los siguientes campos: " +
          errores.join(", ")
      );
      setShowError(true);
      console.log(paisDestinatario);
      return false;
    }
    if(cpRemitente==="75700"){
      setErrorMessage(
        "Código postal de remitente sin servicio"
      );
      setShowError(true);
      console.log(paisDestinatario);
      return false;
    }
    return true;
  };
  // console.log(listadoCarriers);

  useEffect(() => {
    setListadoCarriers(data);
    // console.log(data);
  }, [data]);
  // useEffect(() => {
  //   // set;
  //   console.log(dataGuia);
  // }, [dataGuia]);

  const handleGenerar = async () => {
    if (!validateDatos()) return;
    const dataGenerar = {
      origin: {
        state: estadoRemitente.value,
        postalCode: cpRemitente,
        street: calleRemitente,
        number: numeroRemitente,
        district: coloniaRemitente,
        city: delegacionRemitente,
        reference: referenciaRemitente,
      },
      destination: {
        name: nombreDestinatario,
        email: emailDestinatario,
        company: empresaDestinatario,
        phone: telefonoDestinatario,
        state: estadoDestinatario.value,
        postalCode: cpDestinatario,
        street: calleDestinatario,
        number: numeroDestinatario,
        district: coloniaDestinatario,
        city: delegacionDestinatario,
        reference: referenciaDestinatario,
      },
      pack: {
        dimensions: {
          length: largo,
          height: alto,
          width: ancho,
        },
        weight: peso,
        content: contenido,
      },
      shipment: {
        carrier: option.carrier,
        service: option.service,
      },
      totalPrice: option.totalPrice,
    };
    // console.log(option);

    await doGenerar(dataGenerar);
    setShowModal(true);
    // setOption({});
  };

  const handleGenerarInternacional = async () => {
    if (!validateDatosInternacional()) return;
    const dataGenerar = {
      origin: {
        state: estadoRemitente.value,
        postalCode: cpRemitente,
        street: calleRemitente,
        number: numeroRemitente,
        district: coloniaRemitente,
        city: delegacionRemitente,
        reference: referenciaRemitente,
      },
      destination: {
        name: nombreDestinatario,
        email: emailDestinatario,
        company: empresaDestinatario,
        phone: telefonoDestinatario,
        state: estadoDestinatario.value,
        postalCode: cpDestinatario,
        street: calleDestinatario,
        number: numeroDestinatario,
        district: coloniaDestinatario,
        city: delegacionDestinatario,
        reference: referenciaDestinatario,
        country: paisDestinatario.value
      },
      pack: {
        dimensions: {
          length: largo,
          height: alto,
          width: ancho,
        },
        weight: peso,
        content: contenido,
        insurance: asegurar,
        items:commodities
      },
      shipment: {
        carrier: option.carrier,
        service: option.service,
      },
      totalPrice: option.totalPrice,
      
    };
    // console.log(option);

    await doGenerar(dataGenerar);
    setShowModal(true);
    // setOption({});
  };

  const handleCotizar = () => {
    if (!validateCotizacion()) return;

    const dataCotizacion = {
      origin: {
        state: estadoRemitente.value,
        postalCode: cpRemitente,
      },
      destination: {
        state: estadoDestinatario.value,
        country: paisDestinatario.value,
        postalCode: cpDestinatario,
      },
      pack: {
        dimensions: {
          length: largo,
          height: alto,
          width: ancho,
        },
        weight: peso,
        insurance: asegurar,
        declaredValue:valorEnvio
      },
    };
    console.log(dataCotizacion);
    doCotizacion(dataCotizacion);
    setShowCotizacion(true);
    // console.log(data);
  };

  return loading || isLoadingDir || isLoadingPaquetes ? (
    <div className={classes.spinner}>
      <CircularProgress />
    </div>
  ) : (
    <>
      {/* <img src={drEnvioLogo} alt="DrEnvio Logo" style={{marginLeft:0,marginRight:0,width:'80%'}}/> */}
      <Grid className={classes.root} container spacing={1}>
        <Grid item sm={12} md={6} lg={6}>
          <Paper className={classes.paper}>
            <Typography
              component={"h1"}
              variant="h6"
              className={classes.titulo}
            >
              Remitente
            </Typography>

            <div className={classes.formCol}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  {direcciones.length === 0 ? (
                    <Fragment></Fragment>
                  ) : (
                    <MSelect
                      items={direcciones.map((el) => ({
                        ...el,
                        label:
                          findDestinatario(el.destinatario, destinatarios) +
                          `: ${el.calle} ${el.numero}`,
                      }))}
                      label="Mis direcciones"
                      selectHandler={handleSelectDirRemitente}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Select
                    className={classes.select}
                    options={estados}
                    placeholder="Estado*"
                    value={estadoRemitente}
                    onChange={setEstadoRemitente}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Código Postal*"
                    color="primary"
                    className={classes.formItem}
                    value={cpRemitente}
                    onChange={(e) =>
                      e ? setCPRemitente(e.target.value) : setCPRemitente("")
                    }
                  />
                </Grid>
              </Grid>
            </div>
          </Paper>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h6" className={classes.titulo}>
              Destinatario
            </Typography>
            <div className={classes.formCol}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  {direcciones.length === 0 ? (
                    <Fragment></Fragment>
                  ) : (
                    <MSelect
                      items={direcciones.map((el) => ({
                        ...el,
                        label:
                          findDestinatario(el.destinatario, destinatarios) +
                          `: ${el.calle} ${el.numero}`,
                      }))}
                      label="Mis direcciones"
                      selectHandler={handleSelectDirDestinatario}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Select
                    className={classes.select}
                    options={paises}
                    placeholder="Pais*"
                    value={paisDestinatario}
                    onChange={setPaisDestinatario}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  {paisDestinatario !== null ? (
                    paisDestinatario.label === "México" ? (
                      <Select
                        className={classes.select}
                        options={estados}
                        placeholder="Estado*"
                        value={estadoDestinatario}
                        onChange={setEstadoDestinatario}
                      />
                    ) : (
                      <Select
                        className={classes.select}
                        options={estadosUS}
                        placeholder="Estado*"
                        value={estadoDestinatario}
                        onChange={setEstadoDestinatario}
                      />
                    )
                  ): (<Select
                    className={classes.select}
                    options={estados}
                    placeholder="Estado*"
                    value={estadoDestinatario}
                    onChange={setEstadoDestinatario}
                  />)}
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Código Postal*"
                    color="primary"
                    className={classes.formItem}
                    value={cpDestinatario}
                    onChange={(e) =>
                      e
                        ? setCPDestinatario(e.target.value)
                        : setCPDestinatario("")
                    }
                  />
                </Grid>
              </Grid>
            </div>
          </Paper>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h6" className={classes.titulo}>
              Paquete
            </Typography>

            <div className={classes.formCol}>
              <Grid container spacing={3}>
                {paquetes.length > 0 && (
                  <Grid item xs={12} sm={12} md={12}>
                    <MSelect
                      items={paquetes.map((el) => ({
                        ...el,
                        label: el.nombre,
                      }))}
                      label="Mis paquetes"
                      selectHandler={handleSelectPaquete}
                      disabled="true"
                    />
                  </Grid>
                )}

                <Grid item sm={12} md={6}>
                  <TextField
                    className={classes.formItem}
                    type="number"
                    variant="outlined"
                    label="Alto*"
                    color="primary"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">cm</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      min: 0,
                    }}
                    value={alto}
                    onChange={(e) =>
                      e ? setAlto(+e.target.value) : setAlto("")
                    }
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    className={classes.formItem}
                    type="number"
                    variant="outlined"
                    label="Largo*"
                    color="primary"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">cm</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      min: 0,
                    }}
                    value={largo}
                    onChange={(e) =>
                      e ? setLargo(+e.target.value) : setLargo("")
                    }
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    className={classes.formItem}
                    type="number"
                    variant="outlined"
                    label="Ancho*"
                    color="primary"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">cm</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      min: 0,
                    }}
                    value={ancho}
                    onChange={(e) =>
                      e ? setAncho(+e.target.value) : setAncho("")
                    }
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    className={classes.formItem}
                    type="number"
                    variant="outlined"
                    label="Peso*"
                    color="primary"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">kg</InputAdornment>
                      ),
                    }}
                    inputProps={{
                      min: 0,
                    }}
                    value={peso}
                    onChange={(e) =>
                      e ? setPeso(+e.target.value) : setPeso("")
                    }
                  />
                </Grid>
                {paisDestinatario.value==="US"?(
                  <Grid item sm={12} md={6}>
                  <TextField
                    className={classes.formItem}
                    type="number"
                    variant="outlined"
                    label="Valor del envío*"
                    color="primary"
                    inputProps={{
                      min: 0,
                    }}
                    value={valorEnvio}
                    onChange={(e) =>
                      e ? setValorEnvio(+e.target.value) : setValorEnvio(0)
                    }
                  />
                </Grid>
                ):(<Fragment></Fragment>)}
                {paisDestinatario.value==="US"?(
                <Grid item sm={12} md={6}>
                  <TextField
                    className={classes.formItem}
                    type="number"
                    variant="outlined"
                    label="Asegurar envío*"
                    color="primary"
                    inputProps={{
                      min: 0,
                    }}
                    value={asegurar}
                    onChange={(e) =>
                      e ? setAsegurar(+e.target.value) : setAsegurar(0)
                    }
                  />
                </Grid>
                ):(<Fragment></Fragment>)}
              </Grid>
            </div>
          </Paper>
        </Grid>
      </Grid>

      <Button
        className={classes.botonCotizar}
        color="primary"
        variant="contained"
        disabled={isLoading}
        onClick={handleCotizar}
      >
        Cotizar
        {isLoading && <CircularProgress color="secondary" />}
      </Button>

      {listadoCarriers && listadoCarriers[0] && showCotizacion && !isLoading && (
        <Grid className={classes.root} container spacing={1}>
          <Grid item sm={12} md={6}>
            <Paper className={classes.paper}>
              <Typography
                component="h1"
                variant="h6"
                className={classes.titulo}
              >
                Opciones:
              </Typography>
              <Grid container spacing={3}>
                <Grid item sm={12} md={12} lg={12}>
                  {listadoCarriers.map((carrier) => (
                    <div key={uuid()}>
                      {carrier &&
                        carrier.map((opcion) => (
                          <div key={uuid()}>
                            {/* {console.log(opcion)} */}
                            <CarrierOption
                              nombre={opcion.carrier}
                              option={opcion}
                              medio={services[opcion.service]}
                              checked={Object.is(option, opcion)}
                              tiempo={opcion.deliveryEstimate}
                              precio={opcion.totalPrice}
                              optionHandler={setOption}
                            />
                          </div>
                        ))}
                    </div>
                  ))}
                </Grid>
                {paisDestinatario.value === "US" ? (
                  <Grid container>
                    <Grid item sm={12} md={12} lg={12}>
                        <Typography component="h1" variant="h6" className={classes.titulo}>
                          Detalles del envío 
                          <Button 
                            style={{marginLeft:10}}
                            onClick={() => {
                              setCommoditie(currentCommodities => [
                                ...currentCommodities,
                                {
                                  id: generate(),
                                  firstName: "",
                                  lastName: ""
                                }
                              ]);
                            }}
                            color="primary"
                            variant="contained"
                            className={classes.botonAgregar}
                          >
                            +
                          </Button>
                        </Typography>
                        <Typography component="h6" variant="h6" className={classes.titulo}>
                          La descripción debe llenarse en inglés y el precio en MXN
                        </Typography>
                      </Grid>
                  {commodities.map((commoditie, index) => (
                    <div class="MuiGrid-container">
                      <Grid item sm={12} md={4} lg={4}>
                        <TextField
                          variant="outlined"
                          label="Descripción"
                          color="primary"
                          className={classes.formItem}
                          value={commoditie.description}
                          onChange={e => {
                            const descripcion = e.target.value;
                            setCommoditie(currentDescription =>
                              produce(currentDescription, v => {
                                v[index].description = descripcion;
                              })
                            );
                          }}
                        />
                      </Grid>
                      <Grid item sm={5} md={3} lg={3}>
                        <TextField
                            variant="outlined"
                            label="Cantidad"
                            color="primary"
                            className={classes.formItem}
                            value={commoditie.quantity}
                            onChange={e => {
                              const cantidad = +e.target.value;
                              setCommoditie(currentCantidad =>
                                produce(currentCantidad, v => {
                                  v[index].quantity = cantidad;
                                })
                              );
                            }}
                        />
                      </Grid>
                      <Grid item sm={5} md={3} lg={3}>
                        <TextField
                            variant="outlined"
                            label="Precio"
                            color="primary"
                            className={classes.formItem}
                            value={commoditie.price}
                            onChange={e => {
                              const precio = +e.target.value;
                              setCommoditie(currentPrecio =>
                                produce(currentPrecio, v => {
                                  v[index].price = precio;
                                })
                              );
                            }}
                        />
                      </Grid>
                      <Grid item sm={2} md={2} lg={2}>
                        {index>0?(<Button
                          className={classes.botonEliminar}
                          color="secondary"
                          variant="contained"
                          onClick={() => {
                            setCommoditie(currentCommoditie =>
                              currentCommoditie.filter(x => x.id !== commoditie.id)
                            );
                          }}
                        >
                        X
                      </Button>):(<Fragment></Fragment>)}
                        
                      </Grid>
                    </div>
                  ))}   
                  </Grid>
                ):(<Fragment></Fragment>)}                          
              </Grid>
            </Paper>
          </Grid>
          <Grid item sm={12} md={6}>
            <Paper className={classes.paper}>
              <Typography
                component="h1"
                variant="h6"
                className={classes.titulo}
              >
                Datos del remitente
              </Typography>
              <div className={classes.formCol}>
                <Grid container spacing={3}>
                  <Grid item sm={12} md={12}>
                    <TextField
                      variant="outlined"
                      label="Contenido del Paquete"
                      color="primary"
                      className={classes.formItem}
                      value={contenido}
                      onChange={(e) =>
                        e ? setContenido(e.target.value) : setCPDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      variant="outlined"
                      label="Calle*"
                      color="primary"
                      className={classes.formItem}
                      value={calleRemitente}
                      onChange={(e) =>
                        e
                          ? setCalleRemitente(e.target.value)
                          : setCalleRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Número*"
                      color="primary"
                      className={classes.formItem}
                      value={numeroRemitente}
                      onChange={(e) =>
                        e
                          ? setNumeroRemitente(e.target.value)
                          : setNumeroRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Colonia*"
                      color="primary"
                      className={classes.formItem}
                      value={coloniaRemitente}
                      onChange={(e) =>
                        e
                          ? setColoniaRemitente(e.target.value)
                          : setColoniaRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Delegación*"
                      color="primary"
                      className={classes.formItem}
                      value={delegacionRemitente}
                      onChange={(e) =>
                        e
                          ? setDelegacionRemitente(e.target.value)
                          : setDelegacionRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <Select
                      className={classes.select}
                      value={estadoRemitente}
                      isDisabled
                    />
                  </Grid>
                  <Grid item sm={12} md={3}>
                    <TextField
                      variant="outlined"
                      label="Código Postal"
                      color="primary"
                      className={classes.formItem}
                      value={cpRemitente}
                      disabled
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      variant="outlined"
                      label="Referencia"
                      color="primary"
                      className={classes.formItem}
                      value={referenciaRemitente}
                      onChange={(e) =>
                        e
                          ? setReferenciaRemitente(e.target.value)
                          : setReferenciaRemitente("")
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </Paper>
            <Paper className={classes.paper}>
              <Typography
                component="h1"
                variant="h6"
                className={classes.titulo}
              >
                Datos del destinatario
              </Typography>
              <div className={classes.formCol}>
                <Grid container spacing={3}>
                  <Grid item sm={12}>
                    <TextField
                      variant="outlined"
                      label="Calle*"
                      color="primary"
                      className={classes.formItem}
                      value={calleDestinatario}
                      onChange={(e) =>
                        e
                          ? setCalleDestinatario(e.target.value)
                          : setCalleDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Número*"
                      color="primary"
                      className={classes.formItem}
                      value={numeroDestinatario}
                      onChange={(e) =>
                        e
                          ? setNumeroDestinatario(e.target.value)
                          : setNumeroDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Colonia*"
                      color="primary"
                      className={classes.formItem}
                      value={coloniaDestinatario}
                      onChange={(e) =>
                        e
                          ? setColoniaDestinatario(e.target.value)
                          : setColoniaDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Delegación*"
                      color="primary"
                      className={classes.formItem}
                      value={delegacionDestinatario}
                      onChange={(e) =>
                        e
                          ? setDelegacionDestinatario(e.target.value)
                          : setDelegacionDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <Select
                      className={classes.select}
                      value={estadoDestinatario}
                      isDisabled
                    />
                  </Grid>
                  <Grid item sm={12} md={3}>
                    <TextField
                      variant="outlined"
                      label="Código Postal*"
                      color="primary"
                      className={classes.formItem}
                      value={cpDestinatario}
                      disabled
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Nombre*"
                      color="primary"
                      className={classes.formItem}
                      value={nombreDestinatario}
                      onChange={(e) =>
                        e
                          ? setNombreDestinatario(e.target.value)
                          : setNombreDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Email*"
                      color="primary"
                      className={classes.formItem}
                      value={emailDestinatario}
                      onChange={(e) =>
                        e
                          ? setEmailDestinatario(e.target.value)
                          : setEmailDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Teléfono*"
                      color="primary"
                      className={classes.formItem}
                      value={telefonoDestinatario}
                      onChange={(e) =>
                        e
                          ? setTelefonoDestinatario(e.target.value)
                          : setTelefonoDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Empresa"
                      color="primary"
                      className={classes.formItem}
                      value={empresaDestinatario}
                      onChange={(e) =>
                        e
                          ? setEmpresaDestinatario(e.target.value)
                          : setEmpresaDestinatario("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      variant="outlined"
                      label="Referencia"
                      color="primary"
                      className={classes.formItem}
                      value={referenciaDestinatario}
                      onChange={(e) =>
                        e
                          ? setReferenciaDestinatario(e.target.value)
                          : setReferenciaDestinatario("")
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </Paper>
            {paisDestinatario.value==="MX"?(
              <Button
                className={classes.botonGenerar}
                variant="contained"
                disabled={isLoadingGuia}
                color="secondary"
                onClick={handleGenerar}
              >
                Generar Guía
                {isLoadingGuia && <CircularProgress color="secondary" />}
              </Button>
            ):(
              <Button
              className={classes.botonGenerar}
              variant="contained"
              disabled={isLoadingGuia}
              color="secondary"
              onClick={handleGenerarInternacional}
            >
              Generar Guía 2
              {isLoadingGuia && <CircularProgress color="secondary" />}
            </Button>
            )}
          </Grid>
        </Grid>
      )}
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={showError}
        autoHideDuration={5000}
        onClose={() => setShowError(false)}
      >
        <SnackbarWrapper
          onClose={() => setShowError(false)}
          variant="error"
          message={errorMessage}
        />
      </Snackbar>
      {errorGuia && (
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left", 
          }}
          open={errorSaldo}
          autoHideDuration={5000}
          onClose={() => setErrorSaldo(false)}
        >
          <SnackbarWrapper
            onClose={() => setErrorSaldo(false)}
            variant="error"
            message={"No tienes saldo suficiente"}
          />
        </Snackbar>
      )}
      {dataGuia && !errorGuia && (
        <Modal
          dataGuia={dataGuia}
          trackingNumber={dataGuia[0].trackingNumber}
          handlerClose={handleModalClose}
          open={showModal}
        />
      )}
    </>
  );
};

export default Cotizacion;
